import { staffCmsModalComponentByType } from '#/modules/staff/cms/modals/staffCmsModalComponentByType';
import { staffGradFairModalComponentByType } from '#/modules/staff/gradFairs/modals/staffGradFairModalComponentByType';
import { dynamic } from '#/utils/dynamic';

export const staffModalComponentByType = {
  DELETE_CONTENT: dynamic(
    () =>
      import('./DeleteContent/StaffDeleteContentModalContainer').then(
        (module) => ({ default: module.StaffDeleteContentModalContainer }),
      ),
    { strategy: 'always' },
  ),
  STAFF_APPROVE_ITEM: dynamic(
    () =>
      import('./ApproveItem/StaffApproveItemModal').then((module) => ({
        default: module.StaffApproveItemModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_CHANGE_PASSWORD: dynamic(
    () =>
      import('./StaffChangePassword/StaffChangePasswordModal').then(
        (module) => ({
          default: module.StaffChangePasswordModal,
        }),
      ),
    { strategy: 'always' },
  ),
  CONFIRM_MERGE_ORG: dynamic(
    () =>
      import('#/modules/staff/orgDashboard/modals/ConfirmMergeOrg/StaffOrgDashboardConfirmMergeOrgModal').then(
        (module) => ({ default: module.StaffOrgDashboardConfirmMergeOrgModal }),
      ),
    { strategy: 'always' },
  ),
  DELETE_CATEGORY: dynamic(
    () =>
      import('./DeleteCategory/StaffDeleteCategoryModalContainer').then(
        (module) => ({ default: module.StaffDeleteCategoryModalContainer }),
      ),
    { strategy: 'always' },
  ),
  REFUND_PAYMENT_MODAL: dynamic(
    () =>
      import('./RefundPayment/StaffRefundPaymentModal').then((module) => ({
        default: module.StaffRefundPaymentModal,
      })),
    { strategy: 'always' },
  ),
  VOID_LINE_ITEM: dynamic(
    () =>
      import('./VoidLineItem/StaffVoidLineItemModalContainer').then(
        (module) => ({
          default: module.StaffVoidLineItemModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  CANCEL_CREDITS: dynamic(
    () =>
      import('./CancelCredits/StaffCancelCreditsModal').then((module) => ({
        default: module.StaffCancelCreditsModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_DELETE_EMAIL_PROMO: dynamic(
    () =>
      import('./DeleteEmailPromo/StaffDeleteEmailPromoModal').then(
        (module) => ({
          default: module.StaffDeleteEmailPromoModal,
        }),
      ),
    { strategy: 'always' },
  ),
  STAFF_DELETE_NOTIFICATION_CONFIGURATION: dynamic(
    () =>
      import('./DeleteNotificationConfiguration/StaffDeleteNotificationConfigurationModal').then(
        (module) => ({
          default: module.StaffDeleteNotificationConfigurationModal,
        }),
      ),
    { strategy: 'always' },
  ),
  DELETE_JOB_FAMILY: dynamic(
    () =>
      import('#/modules/staff/cms/compDb/modals/DeleteJobFamily/StaffDeleteJobFamilyModalContainer').then(
        (module) => ({ default: module.StaffDeleteJobFamilyModalContainer }),
      ),
    { strategy: 'always' },
  ),
  DELETE_JOB_TITLE: dynamic(
    () =>
      import('./DeleteJobTitle/StaffDeleteJobTitleModal').then((module) => ({
        default: module.StaffDeleteJobTitleModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_LOGIN_AS_USER: dynamic(
    () =>
      import('./StaffLoginAs/StaffLoginAsModalContainer').then((module) => ({
        default: module.StaffLoginAsModalContainer,
      })),
    { strategy: 'always' },
  ),
  DELETE_LOCATION_GROUP: dynamic(
    () =>
      import('./DeleteLocationGroup/StaffDeleteLocationGroupModalContainer').then(
        (module) => ({
          default: module.StaffDeleteLocationGroupModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  DELETE_LOCATION: dynamic(
    () =>
      import('./DeleteLandingPageLocation/StaffDeleteLandingPageLocationModalContainer').then(
        (module) => ({
          default: module.StaffDeleteLandingPageLocationModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  ...staffCmsModalComponentByType,
  ...staffGradFairModalComponentByType,
} as const satisfies Record<string, unknown>;
